(function () {
  'use strict';

  angular.module('ringbaPortal').component('callLogVueContainer', {
    bindings: {
    },
    controller: CallLogVueController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/reporting-v2/call-log-vue-container.view.html'
  });

  function CallLogVueController(
    $stateParams
  ) {
    'ngInject';

    const vm = this;
    const overrideKeysForNewCallLogs = {
      'affiliateName': 'publisherName'
    };

    vm.$onInit = onInit;

    function onInit() {
      vm.reportId = $stateParams.reportId ? $stateParams.reportId : null;

      const filterKeys = $stateParams.filterkey && $stateParams.filterkey.split(',').map(function (filterKey) {
        return overrideKeysForNewCallLogs[filterKey] || filterKey;
      });

      vm.queryParams = {
        filterKeys: filterKeys,
        isGroup: !!$stateParams.filterisgroup,
        filterValues: $stateParams.filtervalue && $stateParams.filtervalue.split(','),
        reportStart: $stateParams.reportstart || '',
        reportEnd: $stateParams.reportend || ''
      };
    }

  }
})();
